import { RouteRecordRaw } from 'vue-router';
const routes: RouteRecordRaw = {
  path: 'bill',
  name: 'bill',
  component: () => import('@/views/bill/index.vue'),
  children: [
    {
      path: 'app-list',
      name: 'appList',
      component: () => import('@/views/bill/appList.vue'),
    },
    {
      path: 'pay-first',
      name: 'payFirst',
      component: () => import('@/views/bill/pay/firstStep.vue'),
    },
    {
      path: 'pay-two',
      name: 'payTwo',
      component: () => import('@/views/bill/pay/twoStep.vue'),
    },
    {
      path: 'corporate-pay-product',
      name: 'corporatePayProduct',
      component: () => import('@/views/bill/pay/corporatePay.vue'),
    },
    {
      path: 'corporate-pay-order',
      name: 'corporatePayOrder',
      component: () => import('@/views/bill/pay/corporatePay.vue'),
    },
    {
      path: 'pay-success',
      name: 'paySuccess',
      component: () => import('@/views/bill/pay/paySuccess.vue'),
    },

    {
      path: 'order-management',
      name: 'orderManagement',
      component: () => import('@/views/bill/order.vue'),
    },
    {
      path: 'billing-management',
      name: 'billingManagement',
      component: () => import('@/views/bill/billing.vue'),
    },
    {
      path: 'tax-info',
      name: 'taxInfo',
      component: () => import('@/views/bill/txaInfo.vue'),
    },
    {
      path: '403',
      name: 'bill403',
      component: () => import('@/views/403/page.vue'),
    },
  ],
};
export default routes;
